var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tinymce-editor"},[_c('editor',{attrs:{"id":_vm.tinymceId,"init":_vm.tinymceInit,"value":_vm.myValue,"disabled":_vm.disabled,"placeholder":_vm.placeholder},on:{"input":_vm.onEditorInput,"onClick":_vm.onClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }